import {BaseLink, withRouter} from "react-router5";
import {useState} from "react";
import {setBookmark} from "../api";
import {PostCategorie} from "./postCategorie";
import {PostContent} from "./postContent";
import {PostSource} from "./postSource";
import {PostContributeur} from "./postContributeur";
import {PostDate} from "./postDate";
import {TagItem} from "./tagItem";
import {useTranslation} from "react-i18next";
import {PostFile} from "./postFile";
import {PostCitation} from "./postCitation";
import SharePopup from "./sharePopup";
import {MarkdownElement} from "../utils/text";


export const PostItem = withRouter(props => {
    const {post, isListItem, bookMarked, router, users, onGeoClick} = props
    const { t } = useTranslation();
    const [init,setInit] = useState(false);
    const [isBookmark,setIsBookmark] = useState(bookMarked);
    const [open, setOpen] = useState(false);

    // target users for sharing/commenting post
    const target_users =
      users.filter((user) => {
	// if the post is confidential, only enable target confidential users
	return user.is_active && (post.confidential ? user.has_confidential_access : true)
      });

    if(!init){
        setInit(true);
    }

    function toggleBookmark(id,unSet){

        let action = "";

        if(!unSet){
            action="set";

        }else{
            action="unset";
        }
        setIsBookmark(!isBookmark);
        setBookmark(id,action);
    }


    const classListItem = (isListItem)? "listItem":"";

    return <div className={'postContainer ' +classListItem }>
        <div className={'topPost'}>
            <div className={'tagsContainer'}>
                { post.geo &&
                  <div onClick={() => { onGeoClick && onGeoClick(post)}} style={onGeoClick ? {cursor: "pointer"} : {}}>
                    <span className={'tagGeo tag'}>{post.geo.item}</span>
                  </div>
                }
                {post.themes.map(theme=><TagItem tag={theme}  router={router} key={theme.id}/>)}
            </div>
            <div className="topPostRight">
		{ post.confidential && <div className="lock-icon"></div> }
                <PostCategorie categorie={post.type}/>
            </div>
        </div>
        <PostContent router={router} isListItem={isListItem} post={post}>
            <div>
                <div>
                    <h3 className={'postTitle'}>{post.title}</h3>
                    { !isListItem && <div className={'postContent'}>
                        <MarkdownElement text={post.description} />
		      </div>
		    }
                    { isListItem && <div className={'postSummary'}>
			<MarkdownElement text={(post.summary || post.description)} />
		      </div>
		    }
                    { isListItem && <p className={'postMore'}>{t('Voir la suite')}</p> }
                </div>
            </div>
        </PostContent>
        <div className={'postSource'}>
            <PostSource source={{url: post.source_url, name: post.source_name}} />
        </div>
        { !isListItem && <PostContributeur router={router} author={post.author}/>
        }
        <div className={'filesContainer'}>
            { !isListItem && post.attachments.map((file)=> <PostFile file={file} key={file.id}/>) }
        </div>
        {!isListItem && <PostCitation contacts={post.contacts} entites={post.entities} /> }
        <div className={'bottomPost'}>

            <div className={'pictoPost'}>
                <BaseLink className={'pictoCommentContainer'} router={router}  routeName="post" routeParams={{id: post.id}} >
                    <div className={'pictoComment'} />
                    <div className={'numberComment'}>
                      { post.comments_count !== 0 ? post.comments_count : "" }
                    </div>
                </BaseLink>
                <div className={'pictoPostPicto'}>
                    <div onClick={()=>{setOpen(!open)}} className={'pictoShare'}></div>
                </div>
                <div className={'pictoPostPicto'}>
                    <div onClick={()=>{toggleBookmark(post.id,isBookmark)}} className={ (isBookmark) ? "pictoSignet active": "pictoSignet" }></div>
                </div>
            </div>

            <PostDate date={post.publish_date || post.inserted_at}/>
        </div>
        <SharePopup id={post.id} open={open} setOpen={setOpen} dataList={target_users} />
    </div>
});
